var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content"},[_c('div',{staticClass:"h-100 d-flex align-items-center"},[_c('div',{staticClass:"container wide-container"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }